import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uniformeModulo } from "src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule";
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DataLoginModel } from '../../model/dataLoginModel';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { GroupSizesService } from "../../services/gruopSize.service";
import { SizeService } from "../../services/size.service";
import { ResponseGrupoSizeModel } from "../../model/responseGrupoSizeModel";
import { ResponseSizeModel } from "../../model/responseSizeModel";
import { ResponseSizePKModel } from "../../model/responseSizePKModel";

@Component({
  selector: 'app-talla-grupo-prenda',
  templateUrl: './talla-grupo-prenda.component.html',
  styleUrls: ['./talla-grupo-prenda.component.css']
})
export class TallaGrupoPrendaComponent implements OnInit {

  dataUsuario: DataLoginModel;
  mostrarFormulario: boolean = false;
  resposiveFull: string;
  resposiveFullFilter: string;
  tallaGrupoModulo: any = {};
  sizeModulo: any = {};

  formularioCrearGrupoTalla: FormGroup;//formulario
  formularioCrearTalla: FormGroup;
  formularioEditTalla: FormGroup;

  textoBuscarGrupo: string;
  textoBuscarSize: string;
  columnDefs: any[];//aggrid
  columnDefsFilter: any[];//aggrid
  rowData: ResponseGrupoSizeModel[] = [];
  rowDataFilter: ResponseSizeModel[] = [];
  frameworkComponents: any;
  frameworkComponentsFiler: any;
  gridApi: any;
  gridColumnApi: any;
  gridApiFilter: any;
  gridColumnApiFilter: any;
  rowSelection: any;
  rowSelectionFilter: any;

  listaVacia: boolean = false;
  listaVaciaFilter: boolean = false;
  idGrupoSize: string = "";

  loading: boolean = false;

  constructor(private fb: FormBuilder, private _util: UtilsService,
    private _groupSizes: GroupSizesService, private _size: SizeService) { }

  ngOnInit() {

    this.dataUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.tallaGrupoModulo = uniformeModulo;
    this.resposiveFull = this.tallaGrupoModulo.div.resposiveFull;

    this.sizeModulo = uniformeModulo;
    this.resposiveFullFilter = this.sizeModulo.div.resposiveFull;

    this.formularioCrearGrupoTalla = this.fb.group({
      grupoSz: ['',[Validators.required, Validators.maxLength(2)]],
      descrp: ['',[Validators.required, Validators.maxLength(30)]]
    });

    this.formularioCrearTalla = this.fb.group({
      codSize: ['',[Validators.required, Validators.maxLength(2)]],
      descrp: ['',[Validators.required, Validators.maxLength(30)]]
    });

    this.formularioEditTalla = this.fb.group({
      codSize: ['',[Validators.required, Validators.maxLength(2)]],
      descrp: ['',[Validators.required, Validators.maxLength(30)]]
    });

    this.cargarGrid();
    this.cargarGridFiler();

    this.getAllGrupoSize();

  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Codigó Grupo',
        field: 'grupoSz',
        filter: true,
        width: 150,
      },
      {
        headerName: 'Descripcion',
        field: 'descrp',
        filter: true,
        width: 360
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.deleteGrupoTalla.bind(this),
          label: "Eliminar",
        }
      },
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  cargarGridFiler() {
    this.columnDefsFilter = [
      {
        headerName: 'Codigó talla',
        field: 'cEUSizesPK.codSize',
        filter: true,
        width: 150,
      },
      {
        headerName: 'Descripcion',
        field: 'descrp',
        filter: true,
        width: 260
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.callModalEditarTalla.bind(this),
          label: "Editar",
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.deleteSize.bind(this),
          label: "Eliminar",
        }
      },
    ];

    this.frameworkComponentsFiler = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelectionFilter = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscarGrupo);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChangedFilter() {
    this.gridApiFilter.setQuickFilter(this.textoBuscarSize);
  }

  onGridReadyFilter(params) {
    this.gridApiFilter = params.api;
    this.gridColumnApiFilter = params.columnApi;
  }

  getAllGrupoSize(){
    this._groupSizes.getAllGroupSizes().subscribe((res:ResponseGrupoSizeModel[])=>{
      this.rowData = res;
      if(this.rowData.length > 0){
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
    },(err)=>{
      console.log(err);
      this.listaVacia = true;
      this._util.mensajeErrorVisto(err.error.message);
    });
  }

  deleteGrupoTalla({rowData}) {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea eliminar el siguiente Grupo de Talla?',
        text: '',
        action: 'Eliminar',
        funcion: this._groupSizes.deleteGroupSize(decodeURI(rowData.grupoSz)),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getAllGrupoSize();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  callModalCrearGrupoTalla(){
    document.getElementById('abrirModalGrupoTalla').click();
  }
  
  agregarGrupoTalla(){
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea guardar el siguiente Grupo de Talla?',
        text: '',
        action: 'Guardar',
        funcion: this._groupSizes.createGroupSize(this.formularioCrearGrupoTalla.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getAllGrupoSize();
      document.getElementById('cerrarModalGrupoTalla').click();
      this.formularioCrearGrupoTalla.reset();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  callSizes(event){
    this.idGrupoSize = event.data.grupoSz;
    this._size.findSizeByGroup(event.data.grupoSz).subscribe((res:ResponseSizeModel[])=>{
      this.rowDataFilter = res;
      if(this.rowDataFilter.length > 0){
        this.listaVaciaFilter = false;
      } else {
        this.listaVaciaFilter = true;
      }
    },(err)=>{
      this.rowDataFilter = [];
      console.log(err);
      this.listaVaciaFilter = true;
      this._util.mensajeErroToast(err.error.message,3000);
    });
  }

  deleteSize({rowData}) {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea eliminar la siguiente Talla?',
        text: '',
        action: 'Eliminar',
        funcion: this._size.deleteSize(decodeURI(rowData.cEUSizesPK.grupoSz), decodeURI(rowData.cEUSizesPK.codSize)),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getAllGrupoSize();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  callModalCrearTalla(){
    if(this.idGrupoSize == ''){
      this._util.mensajeErrorVisto("Debe seleccionar un Grupo de Talla")
    }else{
      document.getElementById('abrirModalTalla').click();
    }
  }

  builTalla(item: any){
    console.log(item);
    let size = new ResponseSizeModel();
    let sizePK = new ResponseSizePKModel();
    sizePK.codSize = item.codSize;
    size.cEUSizesPK = sizePK;
    size.descrp = item.descrp;
    return size;
  }

  agregarTalla(){
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea guardar la siguiente Talla?',
        text: '',
        action: 'Guardar',
        funcion: this._size.createEditSize(this.idGrupoSize, this.builTalla(this.formularioCrearTalla.value)),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getAllGrupoSize();
      document.getElementById('cerrarModalTalla').click();
      this.formularioCrearTalla.reset();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

  callModalEditarTalla({rowData}){
    this.formularioEditTalla.get('codSize').setValue(rowData.cEUSizesPK.codSize);
    this.formularioEditTalla.get('descrp').setValue(rowData.descrp);
    document.getElementById('abrirModalTallaEdit').click();
  }

  editarTalla() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Está seguro que desea editar la siguiente Talla?',
        text: '',
        action: 'Editar',
        funcion: this._size.createEditSize(this.idGrupoSize, this.builTalla(this.formularioEditTalla.value)),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      document.getElementById('cerrarModalTallaEdit').click();
      this.formularioEditTalla.reset();
    }).catch((err) => { 
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message); 
    });
  }

}
